import { render, staticRenderFns } from "./ModuloPage.vue?vue&type=template&id=4a3e657e"
import script from "./ModuloPage.vue?vue&type=script&lang=js"
export * from "./ModuloPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports